import React from 'react';

import { Typography } from '@mui/material';
import { FieldRenderProps } from 'react-final-form';

type OwnProps = {
  className?: string;
};
export type ErrorMessageProps = Pick<
  FieldRenderProps<string | number | boolean, HTMLElement>,
  'meta' | 'name'
> &
  OwnProps;
export const ErrorMessage = ({ meta, name, className }: ErrorMessageProps) => {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment>
      {(meta.error || meta.submitError) && meta.touched && (
        <Typography
          component="p"
          variant="caption"
          color="error"
          className={className}
          data-testid={`${name}-error`}
        >
          {meta.error || meta.submitError}
        </Typography>
      )}
    </React.Fragment>
  );
};
